import $ from 'jquery';

const User = function() {
  $(document).ready(function(){
    const $categorySelect = $('#professional-category-select');
    const $addButton = $('#add-category-btn');
    const $container = $('[data-user-id]');
    const $hiddenInputsContainer = $('#professional-categories-hidden-inputs');
    const $categoriesContainer = $('#professional-categories-container');

    if ($categorySelect.length === 0 || $addButton.length === 0) {
      return;
    }

    const userId = $container.length ? $container.data('user-id') : null;
    const isNewUser = $container.length ? $container.data('is-new-user') === true : false;

    // Enable/disable button based on selection
    $categorySelect.on('change', function() {
      $addButton.prop('disabled', !this.value);
    });

    // Handle add button click
    $addButton.on('click', function() {
      const categoryId = $categorySelect.val();
      const categoryName = $categorySelect.find('option:selected').text();

      if (!categoryId) {
        return;
      }

      addCategoryToNewUser(categoryId, categoryName);
    });

    function addCategoryToNewUser(categoryId, categoryName) {
      // Check if category already exists in the hidden fields
      if ($(`input[name="professional_category[${categoryId}]"]`).length > 0) {
        alert('Aquesta categoria ja està afegida');
        return;
      }

      // Create hidden input with the new format: professional_category[id]
      const $hiddenInput = $('<input>', {
        type: 'hidden',
        name: `professional_category[${categoryId}]`,
        value: categoryId,
        'data-category-id': categoryId
      });

      // Add hidden input to the dedicated container
      $hiddenInputsContainer.append($hiddenInput);

      // Add the category pill to the UI
      addCategoryPill(categoryId, categoryName, true);

      // Reset the select
      $categorySelect.val('').trigger('change');
      $addButton.prop('disabled', true);
    }

    function addCategoryPill(categoryId, categoryName, isNewUser) {
      // Create the pill HTML
      const pillId = `pc-${categoryId}`;
      const removeId = `remove-id-${categoryId}`;
      const displayText = `${categoryName}`;

      const $pill = $(`
        <span id="${pillId}" class="table-pill mr-2 mb-2">
          ${displayText}
          <span id="${removeId}" class="remove-category" style="cursor: pointer; margin-left: 5px;">
            <i class="fa fa-times"></i>
          </span>
        </span>
      `);

      // Add the pill to the container
      $categoriesContainer.append($pill);

      // Add click event for remove button
      $(`#${removeId}`).on('click', function() {
        removeCategory(categoryId, isNewUser);
      });
    }

    function removeCategory(categoryId, isNewUser) {
      $(`input[name="professional_category[${categoryId}]"]`).remove();

      // Remove the pill from UI
      $(`#pc-${categoryId}`).remove();

      // If no categories left, hide the container
      if ($categoriesContainer.children().length === 0) {
        $categoriesContainer.hide();
      }
    }

    // Initialize existing categories
    initializeExistingCategories();

    function initializeExistingCategories() {
      // Show container if there are existing pills
      if ($categoriesContainer.children().length > 0) {
        $categoriesContainer.show();
      }

      $('.table-pill .remove-category').each(function() {
        const $removeBtn = $(this);
        const pillId = $removeBtn.closest('.table-pill').attr('id');
        const categoryId = pillId.replace('pc-', '');

        $removeBtn.on('click', function() {
          removeCategory(categoryId, isNewUser);
        });
      });
    }
  });
};

export default User;
